import { AccountStateInterface } from "./types";
import Account from "@/types/app/accounts";

export default {
  getModalNewAccountState(state: AccountStateInterface): boolean {
    return state.modalNewAccount;
  },
  getModalCloneAccountState(state: AccountStateInterface): boolean {
    return state.modalCloneAccount;
  },
  getModalAccountGroupingState(state: AccountStateInterface): boolean {
    return state.modalAccountGrouping;
  },
  getModalAccountState(state: AccountStateInterface): boolean {
    return state.modalAccount;
  },
  getAccountState(state: AccountStateInterface): Account {
    return state.account;
  },
  getAccountsState(state: AccountStateInterface): Account[] {
    return state.accounts;
  },
  getAccountSent(state: AccountStateInterface): boolean {
    return state.accountSent;
  },
};
